import Vue from "vue";
import App from "./App.vue";
import AdminButton from "@shared/components/AdminButton.vue";
import router from "./router";
import store from "./store";
import "element-ui/lib/theme-chalk/index.css";
import "@/styles/common.scss";
import "@/plugins/element-ui";
import mountManagementApp from "@shared/mountManagementApp.cjs";

mountManagementApp({
  Framework: Vue,
  RootComponent: App,
  AdminButton,
  router,
  store,
  productionTip: false,
  authenticatedActions: ["getAccountInfo", "getDashboardCounts"],
});
